"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_TIMEOUT = void 0;
const SECONDS = 1000;
exports.DEFAULT_TIMEOUT = 30 * SECONDS;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGltZW91dC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21tb24vYXBpcy90aW1lb3V0LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLE1BQU0sT0FBTyxHQUFHLElBQUksQ0FBQztBQUNSLFFBQUEsZUFBZSxHQUFHLEVBQUUsR0FBRyxPQUFPLENBQUMifQ==